import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "swiper-wrapper" }
const _hoisted_2 = { class: "swiper-zoom-container" }
const _hoisted_3 = ["src"]

import { ref, Ref, onMounted, watch, nextTick } from 'vue'
import { preloadImages, preventBodyScroll } from '@/utils/utils'
import 'swiper/swiper-bundle.css'
import { type Swiper } from 'swiper'


export default /*@__PURE__*/_defineComponent({
  __name: 'PhotoGallery',
  props: {
    initialize: {
        type: Boolean,
        required: true,
    },
},
  setup(__props) {

const swiperElement: Ref<HTMLElement | null> = ref(null)

const swiperInstance: Ref<Swiper | null> = ref(null)

const props = __props

const fullScreen = ref(false)

const slides = [
    require('@/assets/prostori-thumbs/cakalnica.jpg'),
    require('@/assets/prostori-thumbs/staff.jpg'),
    require('@/assets/prostori-thumbs/sneaky.jpg'),
    require('@/assets/prostori-thumbs/pisarna.jpg'),
    require('@/assets/prostori-thumbs/rentgen.jpg'),
    require('@/assets/prostori-thumbs/behind.jpg'),
    require('@/assets/prostori-thumbs/narrow.jpg'),
]

onMounted(async () => setTimeout(() => preloadImages([slides[0]]), 3000))

watch(
    () => props.initialize,
    async init => {
        if (init && !swiperInstance.value) iniSwiper()
    },
)

let styleTag: HTMLStyleElement | null = null

async function toggleFullscreen(value?: boolean): Promise<void> {
    if (fullScreen.value === value || !swiperInstance.value) return

    fullScreen.value = value ?? !fullScreen.value

    await nextTick() // Prevent swiper flicker

    swiperInstance.value.update()

    if (fullScreen.value) {
        swiperInstance.value.zoom.enable()
        swiperInstance.value.autoplay.pause()

        styleTag = preventBodyScroll('html { background-color: #caced2cc; }')
    } else {
        swiperInstance.value.zoom.out()
        swiperInstance.value.zoom.disable()
        swiperInstance.value.autoplay.resume()

        styleTag?.remove()
        styleTag = null
    }

    swiperInstance.value.update()
}

async function iniSwiper() {
    const { default: Swiper } = await import('swiper')
    const { Autoplay, Pagination, Navigation, Zoom } = await import('swiper/modules')

    if (!swiperElement.value) {
        throw new Error('Swiper not initialized')
    }
    swiperInstance.value = new Swiper(swiperElement.value, {
        modules: [Autoplay, Pagination, Navigation, Zoom],
        autoplay: {
            delay: 300000,
            disableOnInteraction: true,
        },
        speed: 900,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        zoom: {
            toggle: true,
            maxRatio: 2,
            minRatio: 1,
            limitToOriginalSize: false,
        },
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        spaceBetween: 0,
        on: {
            init(instance) {
                instance.autoplay.resume()
            },
        },
    })
    swiperInstance.value.zoom.disable()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container", { 'full-screen': fullScreen.value }])
  }, [
    _createElementVNode("div", {
      class: "backdrop",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleFullscreen(false)))
    }),
    (__props.initialize)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "swiperElement",
          ref: swiperElement,
          class: "swiper"
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(slides, (slide) => {
              return _createElementVNode("div", {
                class: "swiper-slide",
                key: slide
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("img", {
                    class: "image card",
                    src: slide,
                    alt: "todo"
                  }, null, 8, _hoisted_3)
                ])
              ])
            }), 64))
          ])
        ], 512))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "full-screen-button",
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (toggleFullscreen()), ["stop"]))
    }),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "nav-button prev swiper-button-prev" }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "nav-button next swiper-button-next" }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "swiper-pagination" }, null, -1))
  ], 2))
}
}

})